var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2458 1.03574C10.8095 0.599414 10.155 0.599414 9.71865 1.03574L5.90078 4.85361L2.08291 1.03574C1.64658 0.599414 0.99209 0.599414 0.555762 1.03574C0.119434 1.47207 0.119434 2.12656 0.555762 2.56289L5.13721 7.14434C5.35537 7.3625 5.57354 7.47158 5.90078 7.47158C6.22803 7.47158 6.44619 7.3625 6.66436 7.14434L11.2458 2.56289C11.6821 2.12656 11.6821 1.47207 11.2458 1.03574Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.495bcf84e71963f1369f517026a894fc.svg";
export { ForwardRef as ReactComponent };